import authSlice from './authSlice'
import vehicleSlice from './vehicleSlice'
import vendorSlice from './vendorSlice'
import holidaySlice from './holidaySlice'
import bookingSlice from './bookingSlice'
import companySlice from './companySlice'
import rewardPointsSlice from './rewardPointsSlice'

const combineReducers = {
    auth: authSlice,
    vehicle: vehicleSlice,
    vendor: vendorSlice,
    holiday: holidaySlice,
    booking: bookingSlice,
    company: companySlice,
    reward: rewardPointsSlice
}

export default combineReducers